type NotEmpty<T> = T extends '' | null | undefined ? never : T;
/**
 *  Returns true when the value is not an empty string, null of undefined
 */
const notEmpty = <T = unknown>(value: T): value is NotEmpty<T> => {
	return (value as unknown as string) !== '' && value !== null && value !== undefined;
};

export default notEmpty;
